import TYPES from './types'

export default (state = {}, action) => {
  const { type } = action
  switch (type) {
    case TYPES.FETCH_STORE_LOCATOR_SUCCESS:
    case TYPES.UPDATE_STORE_LOCATOR_SUCCESS:
      return action.payload
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/storeLocator/reducer.js